export default __webpack_public_path__ + "static/media/cpa.98bfb9af.png";